"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Code, TrendingUp } from "lucide-react";
export default function LExpertiseJennyMartel() {
  const imageReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const textReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const binaryString = Array(200).fill("JENNY MARTEL COURTIÈRE HYPOTHÉCAIRE ").join(" ");
  return <section data-section-id="260024" id="lexpertise-jenny-martel" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_100%)] opacity-[0.03]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={imageReveal.ref} className={`relative transition-all duration-1000 ease-out ${imageReveal.isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            {}
            <div className="relative p-3 md:p-5 rounded-md border border-border bg-card/40 backdrop-blur-md shadow-xl shadow-primary/5 transform -rotate-1 hover:rotate-0 transition-transform duration-500">
              <div className="overflow-hidden rounded-md bg-muted relative aspect-[4/5]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/jenny_martel_portrait_professional.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/jenny_martel_portrait_professional.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691062/img/jenny_martel_portrait_professional.png-wvc-sizes" alt="Jenny Martel - Courtière Hypothécaire au Québec" className="w-full h-full object-cover grayscale contrast-110 hover:grayscale-0 hover:contrast-100 transition-all duration-700" loading="lazy" src="https://patient-redbird.10web.cloud/wp-content/uploads/2026/05/Jenny-Courtier-Hypo.jpg" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent pointer-events-none"></div>
              </div>
              
              {}
              <div className="absolute -bottom-6 -right-6 bg-card border border-border p-4 rounded-md shadow-2xl flex items-center gap-4 animate-bounce" style={{
              animationDuration: '4s'
            }}>
                <div className="bg-secondary/20 p-2 rounded-md text-primary">
                  <TrendingUp className="size-6" />
                </div>
                <div>
                  <p className="font-default font-bold text-lg leading-none">Expertise</p>
                  <p className="text-xs text-muted-foreground">Dossiers Complexes</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={textReveal.ref} className={`relative transition-all duration-1000 delay-200 ease-out ${textReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="absolute -inset-x-10 -inset-y-20 overflow-hidden pointer-events-none opacity-[0.04] select-none flex flex-wrap content-start text-[14px] leading-none font-mono text-primary break-all z-0" aria-hidden="true">
              {binaryString}
            </div>

            <div className="relative z-10">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-muted border border-border text-primary text-sm font-medium mb-6">
                <Code className="size-4" />
                <span>Rapidité & Professionnalisme</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold mb-6 tracking-tight">Refusé par votre banque?<br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70 !text-4xl" data-ast-id="f:/src/pages/Home/sections/LExpertiseJennyMartel.tsx|sig:vtbrfh" data-ast-start="4067" data-ast-end="4223">Parlons-en avant d'abandonner votre projet.</span></h2>
              
              <div className="w-20 h-1 bg-secondary mb-8 rounded-md"></div>

              <div className="space-y-6 text-muted-foreground text-lg font-default leading-relaxed">
                <p>Bonjour moi c'est Jen!<br /><br />Au fil des années, j'ai accompagné des clients dans toutes sortes de situations hypothécaires. Une chose revient souvent : plusieurs croient qu'un refus de la banque signifie la fin du projet.&nbsp;<br />Dans bien des cas, ce n'est pourtant pas le cas.</p>
                <p>Travailleur autonome, crédit affecté par un événement de vie, consolidation de dettes, refus bancaire ou dossier qui sort des critères habituels... chaque situation mérite d'être analysée avant de conclure qu'il n'y a pas de solution.<br /><br />Trop souvent, des gens arrivent découragés après avoir reçu un refus. Pourtant, un refus dans une institution ne veut pas toujours dire que le projet est impossible</p>
                <p>Mon rôle est simple : prendre le temps de comprendre votre situation, analyser toutes les options disponibles et vous accompagner du début jusqu'à la réalisation de votre projet.<br /><br />Je privilégie une approche humaine, transparente et sans jugement. Chaque dossier est différent, chaque histoire est différente, et chaque client mérite d'être écouté avant qu'une décision soit prise.<br /><br />Mon objectif n'est pas seulement d'obtenir un financement, mais de vous aider à trouver la solution qui convient réellement à votre situation.</p>
              </div>

              {}
              <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8 border-t border-border/50 pt-8">
                <div>
                  <p className="text-3xl md:text-4xl font-serif italic text-foreground tracking-wider">
                    Jenny Martel
                  </p>
                  <p className="text-sm text-primary font-medium mt-1 uppercase tracking-widest">Courtière Hypothécaire&nbsp;</p>
                </div>
                
                <Button asChild size="lg" className="rounded-md group bg-primary hover:bg-primary/90 text-primary-foreground">
                  
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}